// extracted by mini-css-extract-plugin
module.exports = {"prependContent":"InputText_prependContent__1DtEk","group":"InputText_group__33wgi","darkLabel":"InputText_darkLabel___9mMu"};